<ng-container *ngIf="ready">
  <!-- Icon-only mode: solid blue circle buttons with tooltips, disabled when
       there's nothing to view. Used in tight headers (e.g. the business card
       title row, where the solid fill matches the other blue actions). -->
  <div *ngIf="iconOnly" class="flex gap-2 align-items-center">
    <button
      pButton
      type="button"
      icon="pi pi-file"
      class="p-button-rounded p-button-sm"
      [disabled]="docCount === 0"
      [pTooltip]="
        docCount === 0 ? 'No documents uploaded' : 'View documents (' + docCount + ')'
      "
      tooltipPosition="top"
      [showDelay]="500"
      (click)="openView('document')"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-image"
      class="p-button-rounded p-button-sm"
      [disabled]="imageCount === 0"
      [pTooltip]="
        imageCount === 0 ? 'No images uploaded' : 'View images (' + imageCount + ')'
      "
      tooltipPosition="top"
      [showDelay]="500"
      (click)="openView('image')"
    ></button>
  </div>

  <!-- Labelled modes -->
  <div *ngIf="!iconOnly" class="flex gap-2 flex-wrap align-items-center">
    <!-- View-only (e.g. arrangement transfer panel): plain buttons, no upload. -->
    <ng-container *ngIf="viewOnly">
      <p-button label="Documents" icon="pi pi-file" [styleClass]="compact ? 'p-button-sm' : ''" (onClick)="openView('document')"></p-button>
      <p-button label="Images" icon="pi pi-image" [styleClass]="compact ? 'p-button-sm' : ''" (onClick)="openView('image')"></p-button>
    </ng-container>
    <!-- Full: view + upload via split-button. -->
    <ng-container *ngIf="!viewOnly">
      <p-splitButton
        label="Documents"
        icon="pi pi-file"
        [styleClass]="compact ? 'p-button-sm' : ''"
        (onClick)="openView('document')"
        [model]="[{ label: 'Upload documents', icon: 'pi pi-upload', command: uploadDocuments }]"
      ></p-splitButton>
      <p-splitButton
        label="Images"
        icon="pi pi-image"
        [styleClass]="compact ? 'p-button-sm' : ''"
        (onClick)="openView('image')"
        [model]="[{ label: 'Upload images', icon: 'pi pi-upload', command: uploadImages }]"
      ></p-splitButton>
    </ng-container>
  </div>
</ng-container>
